(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loopi-collection-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll(
      '[data-loopi-collection-header]'
    );

    if (!headers.length) return;

    const normaliseValue = (value) => {
      return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/[’']/g, '')
        .replace(/\s+/g, '');
    };

    const getQuickFilterConfig = (
      collectionHandle,
      collectionTitle
    ) => {
      const handle = String(collectionHandle || '').toLowerCase();
      const title = String(collectionTitle || '').toLowerCase();
      const context = `${handle} ${title}`;

      const includesAny = (values) =>
        values.some((value) => context.includes(value));

      const isWomens = includesAny([
        'womens', "women's", 'women-', 'female'
      ]);

      const isMens =
        !isWomens &&
        includesAny([
          'mens', "men's", 'men-', ' male '
        ]);

      const isGirls = includesAny([
        'girls', "girl's", 'girl-'
      ]);

      const isBoys = includesAny([
        'boys', "boy's", 'boy-'
      ]);

      const isKids =
        includesAny([
          'kids', 'kid-', 'children', 'childrens',
          "children's", 'junior'
        ]) ||
        isGirls ||
        isBoys;

      const isFootwear = includesAny([
        'shoes', 'trainers', 'boots', 'footwear',
        'sandals', 'sneakers'
      ]);

      const isWaistSizedBottom = includesAny([
        'jeans', 'trousers', 'chinos', 'pants'
      ]);

      const isDress = includesAny([
        'dress', 'dresses'
      ]);

      const isNonWaistGarment = includesAny([
        'jacket', 'jackets', 'coat', 'coats',
        'shirt', 'shirts', 't-shirt', 't-shirts',
        'tee', 'tees', 'top', 'tops', 'hoodie',
        'hoodies', 'sweatshirt', 'sweatshirts',
        'jumper', 'jumpers', 'dress', 'dresses',
        'skirt', 'skirts', 'shorts', 'dungarees',
        'overalls'
      ]);

      const usesWaistSizing =
        isWaistSizedBottom &&
        !isNonWaistGarment;

      const standardSizeConfig = {
        label: 'Popular sizes',
        facets: ['Size', 'Sizes'],
        options: [
          { label: 'XS', aliases: ['XS', 'Extra Small'] },
          { label: 'S', aliases: ['S', 'Small'] },
          { label: 'M', aliases: ['M', 'Medium'] },
          { label: 'L', aliases: ['L', 'Large'] },
          { label: 'XL', aliases: ['XL', 'Extra Large'] },
          { label: '2XL', aliases: ['2XL', 'XXL'] }
        ]
      };

      if (isKids && !isBoys && !isGirls) {
        return {
          label: 'Shop by gender',
          facets: ['Gender'],
          options: [
            { label: 'Boys', aliases: ['Boys', "Boy's", 'Boy'] },
            { label: 'Girls', aliases: ['Girls', "Girl's", 'Girl'] }
          ]
        };
      }

      if (isBoys || isGirls) {
        return {
          label: 'Popular sizes',
          facets: ['Size', 'Sizes'],
          options: [
            { label: '3-4Y', aliases: ['3-4Y', '3-4 Years', 'Age 3-4'] },
            { label: '5-6Y', aliases: ['5-6Y', '5-6 Years', 'Age 5-6'] },
            { label: '7-8Y', aliases: ['7-8Y', '7-8 Years', 'Age 7-8'] },
            { label: '9-10Y', aliases: ['9-10Y', '9-10 Years', 'Age 9-10'] },
            { label: '11-12Y', aliases: ['11-12Y', '11-12 Years', 'Age 11-12'] },
            { label: '13-14Y', aliases: ['13-14Y', '13-14 Years', 'Age 13-14'] }
          ]
        };
      }

      if (isDress) {
        return {
          label: 'Popular sizes',
          facets: ['Size', 'Sizes'],
          options: [
            { label: '6', aliases: ['6', 'UK6', 'UK 6'] },
            { label: '8', aliases: ['8', 'UK8', 'UK 8'] },
            { label: '10', aliases: ['10', 'UK10', 'UK 10'] },
            { label: '12', aliases: ['12', 'UK12', 'UK 12'] },
            { label: '14', aliases: ['14', 'UK14', 'UK 14'] },
            { label: '16', aliases: ['16', 'UK16', 'UK 16'] }
          ]
        };
      }

      if (!isMens && !isWomens) {
        return {
          label: 'Shop by gender',
          facets: ['Gender'],
          options: [
            { label: 'Mens', aliases: ['Mens', "Men's", 'Men', 'Male'] },
            { label: 'Womens', aliases: ['Womens', "Women's", 'Women', 'Female'] }
          ]
        };
      }

      if (isMens && usesWaistSizing) {
        return {
          label: 'Popular sizes',
          facets: ['Waist', 'Size', 'Sizes'],
          options: [
            { label: 'W30', aliases: ['W30', '30', '30W'] },
            { label: 'W32', aliases: ['W32', '32', '32W'] },
            { label: 'W34', aliases: ['W34', '34', '34W'] },
            { label: 'W36', aliases: ['W36', '36', '36W'] },
            { label: 'W38', aliases: ['W38', '38', '38W'] },
            { label: 'W40', aliases: ['W40', '40', '40W'] }
          ]
        };
      }

      if (isWomens && usesWaistSizing) {
        return {
          label: 'Popular sizes',
          facets: ['Waist', 'Size', 'Sizes'],
          options: [
            { label: 'W26', aliases: ['W26', '26', '26W'] },
            { label: 'W28', aliases: ['W28', '28', '28W'] },
            { label: 'W30', aliases: ['W30', '30', '30W'] },
            { label: 'W32', aliases: ['W32', '32', '32W'] },
            { label: 'W34', aliases: ['W34', '34', '34W'] },
            { label: 'W36', aliases: ['W36', '36', '36W'] }
          ]
        };
      }

      if (isMens && isFootwear) {
        return {
          label: 'Popular sizes',
          facets: ['Size', 'Shoe Size', 'Footwear Size'],
          options: [
            { label: '7', aliases: ['7', 'UK7', 'UK 7'] },
            { label: '8', aliases: ['8', 'UK8', 'UK 8'] },
            { label: '9', aliases: ['9', 'UK9', 'UK 9'] },
            { label: '10', aliases: ['10', 'UK10', 'UK 10'] },
            { label: '11', aliases: ['11', 'UK11', 'UK 11'] },
            { label: '12', aliases: ['12', 'UK12', 'UK 12'] }
          ]
        };
      }

      if (isWomens && isFootwear) {
        return {
          label: 'Popular sizes',
          facets: ['Size', 'Shoe Size', 'Footwear Size'],
          options: [
            { label: '4', aliases: ['4', 'UK4', 'UK 4'] },
            { label: '5', aliases: ['5', 'UK5', 'UK 5'] },
            { label: '6', aliases: ['6', 'UK6', 'UK 6'] },
            { label: '7', aliases: ['7', 'UK7', 'UK 7'] },
            { label: '8', aliases: ['8', 'UK8', 'UK 8'] },
            { label: '9', aliases: ['9', 'UK9', 'UK 9'] }
          ]
        };
      }

      return standardSizeConfig;
    };

    const getSearchaniseInputs = (facetTitle) => {
      const requestedFacet = normaliseValue(facetTitle);

      return Array.from(
        document.querySelectorAll(
          '.snize-product-filters-checkbox'
        )
      ).filter((input) => {
        return (
          normaliseValue(input.dataset.seFacetDefaultTitle) ===
          requestedFacet
        );
      });
    };


    const getConfigFacets = (config) => {
      if (Array.isArray(config?.facets)) {
        return config.facets.filter(Boolean);
      }

      if (config?.facet) {
        return [config.facet];
      }

      return [];
    };

    const resolveLiveFacet = (config) => {
      const facets = getConfigFacets(config);

      for (const facet of facets) {
        if (getSearchaniseInputs(facet).length) {
          return facet;
        }
      }

      return facets[0] || '';
    };

    const getMatchingInput = (inputs, aliases) => {
      const normalisedAliases = aliases.map(normaliseValue);

      const matches = inputs.filter((input) => {
        const values = [
          input.value,
          input.dataset.seFacetValueTitle
        ].map(normaliseValue);

        return values.some((value) =>
          normalisedAliases.includes(value)
        );
      });

      /*
       * Searchanise can output duplicate filter inputs for
       * desktop and mobile. When a value is already active,
       * always target the checked copy first so clicking the
       * shortcut removes the filter instead of selecting an
       * unchecked duplicate again.
       */
      return (
        matches.find((input) => input.checked) ||
        matches.find((input) =>
          input.getAttribute('aria-checked') === 'true'
        ) ||
        matches[0]
      );
    };

    const getInputLabel = (input) => {
  const rawLabel =
    input?.dataset?.seFacetValueTitle ??
    input?.value ??
    '';

  const label = String(rawLabel).trim();
  const normalisedLabel = label.toLowerCase();

  if (
    !label ||
    normalisedLabel === 'undefined' ||
    normalisedLabel === 'null' ||
    normalisedLabel === 'nan'
  ) {
    return '';
  }

  return label;
};

const getInputCount = (input) => {
  const filterItem =
    input.closest('li') ||
    input.closest('.snize-product-filters-list-item') ||
    input.parentElement;

  const countElement = filterItem?.querySelector(
    '.snize-product-filters-count'
  );

  const count = parseInt(
    String(countElement?.textContent || '').replace(/\D/g, ''),
    10
  );

  return Number.isNaN(count) ? 0 : count;
};

const getAvailableOptions = (config) => {
  const facetTitle = resolveLiveFacet(config);

  if (!facetTitle) return [];

  return getSearchaniseInputs(facetTitle)
    .filter((input) => {
      if (input.disabled) return false;

      const count = getInputCount(input);

      /*
       * Some Searchanise themes do not output a count.
       * A missing count should still be considered available.
       */
      return count > 0 || !input.closest('li')?.querySelector(
        '.snize-product-filters-count'
      );
    })
    .map((input) => {
      return {
        input,
        label: getInputLabel(input),
        normalisedLabel: normaliseValue(getInputLabel(input)),
        count: getInputCount(input)
      };
    })
    .filter((option) => option.label !== '');
};

const buildQuickFilterOptions = (config) => {
  const availableOptions = getAvailableOptions(config);

  if (!availableOptions.length) return [];

  const selectedOptions = [];
  const usedInputs = new Set();

  /*
   * First add preferred configured options, but only when
   * the corresponding Searchanise filter genuinely exists.
   */
  config.options.forEach((preferredOption) => {
    if (selectedOptions.length >= 6) return;

    const aliases = preferredOption.aliases.map(normaliseValue);

    const match = availableOptions.find((availableOption) => {
      return (
        !usedInputs.has(availableOption.input) &&
        aliases.includes(availableOption.normalisedLabel)
      );
    });

    if (!match) return;

    selectedOptions.push({
      label: preferredOption.label,
      aliases: preferredOption.aliases,
      input: match.input
    });

    usedInputs.add(match.input);
  });

  /*
   * Fill any empty spaces using other real Searchanise values.
   * This means we always show up to six valid shortcuts.
   */
  availableOptions.forEach((availableOption) => {
    if (selectedOptions.length >= 6) return;
    if (usedInputs.has(availableOption.input)) return;

    const fallbackLabel = String(
      availableOption.label || ''
    ).trim();

    if (!fallbackLabel) return;

    selectedOptions.push({
      label: fallbackLabel,
      aliases: [fallbackLabel],
      input: availableOption.input
    });

    usedInputs.add(availableOption.input);
  });

  return selectedOptions;
};

const initialiseHeader = (header) => {
  const wrapper = header.querySelector(
    '[data-loopi-quick-filters]'
  );

  const label = header.querySelector(
    '[data-loopi-filter-label]'
  );

  const buttonContainer = header.querySelector(
    '[data-loopi-filter-buttons]'
  );

  if (!wrapper || !label || !buttonContainer) return;

  const getButtonsContentWidth = () => {
    const buttons = Array.from(
      buttonContainer.querySelectorAll(
        '.collection-page-header__size-button:not([hidden])'
      )
    );

    if (!buttons.length) return 0;

    const styles = window.getComputedStyle(buttonContainer);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    return buttons.reduce(
      (total, button) => total + button.getBoundingClientRect().width,
      0
    ) + Math.max(0, buttons.length - 1) * gap;
  };

  const updateMobileScrollbar = () => {
    const isMobile = window.matchMedia(
      '(max-width: 749px)'
    ).matches;

    if (!isMobile) {
      wrapper.classList.remove('is-scrollable');
      return;
    }

    /*
     * Measure the actual pills against the safe width inside
     * the 20px page gutters. This is independent of the current
     * .is-scrollable layout, so the class cannot oscillate.
     */
    const safeWidth = Math.max(
      0,
      wrapper.getBoundingClientRect().width - 40
    );

    const contentWidth = getButtonsContentWidth();
    const isScrollable = contentWidth > safeWidth + 1;

    wrapper.classList.toggle(
      'is-scrollable',
      isScrollable
    );

    if (!isScrollable) {
      buttonContainer.scrollLeft = 0;

      wrapper.style.setProperty(
        '--loopi-scroll-ratio',
        '1'
      );

      wrapper.style.setProperty(
        '--loopi-scroll-progress',
        '0'
      );

      return;
    }

    const maxScroll = Math.max(
      0,
      buttonContainer.scrollWidth - buttonContainer.clientWidth
    );

    const ratio =
      buttonContainer.scrollWidth > 0
        ? Math.min(
            1,
            buttonContainer.clientWidth /
              buttonContainer.scrollWidth
          )
        : 1;

    const progress =
      maxScroll > 0
        ? Math.min(
            1,
            Math.max(0, buttonContainer.scrollLeft / maxScroll)
          )
        : 0;

    wrapper.style.setProperty(
      '--loopi-scroll-ratio',
      String(ratio)
    );

    wrapper.style.setProperty(
      '--loopi-scroll-progress',
      String(progress)
    );
  };

  buttonContainer.addEventListener(
    'scroll',
    updateMobileScrollbar,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateMobileScrollbar,
    { passive: true }
  );

  const config = getQuickFilterConfig(
    header.dataset.collectionHandle || '',
    header.dataset.collectionTitle || ''
  );

  if (
    !config ||
    !getConfigFacets(config).length ||
    !Array.isArray(config.options)
  ) {
    wrapper.hidden = true;
    buttonContainer.innerHTML = '';
    return;
  }

  let renderedOptionsSignature = '';

  const renderButtons = () => {
    const options = buildQuickFilterOptions(config);

    label.textContent =
      String(config.label || '').trim() || 'Popular sizes';

    const optionsSignature = options
      .map((option) => {
        const aliases = Array.isArray(option.aliases)
          ? option.aliases.join('|')
          : '';

        return `${option.label}::${aliases}`;
      })
      .join('||');

    if (!options.length) {
      renderedOptionsSignature = '';
      buttonContainer.innerHTML = '';
      wrapper.hidden = true;
      return;
    }

    if (
      optionsSignature === renderedOptionsSignature &&
      buttonContainer.children.length === options.length
    ) {
      wrapper.hidden = false;
      return;
    }

    renderedOptionsSignature = optionsSignature;
    buttonContainer.innerHTML = '';

    options.forEach((option) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className =
        'collection-page-header__size-button';

      const buttonLabel = String(
        option.label || ''
      ).trim();

      if (!buttonLabel) return;

      button.textContent = buttonLabel;
      button.dataset.loopiAliases =
        JSON.stringify(
          Array.isArray(option.aliases)
            ? option.aliases.filter(Boolean)
            : [buttonLabel]
        );

      button.setAttribute(
        'aria-pressed',
        option.input.checked ? 'true' : 'false'
      );

      button.addEventListener('click', () => {
        const inputs = getSearchaniseInputs(resolveLiveFacet(config));

        const aliases = JSON.parse(
          button.dataset.loopiAliases || '[]'
        );

        const matchingInput = getMatchingInput(
          inputs,
          aliases
        );

        if (!matchingInput) return;

        matchingInput.click();

        window.setTimeout(syncButtons, 100);
        window.setTimeout(syncButtons, 500);
      });

      buttonContainer.appendChild(button);
    });

    wrapper.hidden = false;

    window.requestAnimationFrame(
      updateMobileScrollbar
    );
  };

  const syncButtons = () => {
    const buttons = Array.from(
      buttonContainer.querySelectorAll(
        '.collection-page-header__size-button'
      )
    );

    if (!buttons.length) {
      renderButtons();
      return;
    }

    let availableButtons = 0;

    buttons.forEach((button) => {
      const inputs = getSearchaniseInputs(resolveLiveFacet(config));

      const aliases = JSON.parse(
        button.dataset.loopiAliases || '[]'
      );

      const matchingInput = getMatchingInput(
        inputs,
        aliases
      );

      if (!matchingInput) {
        button.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-pressed', 'false');
        return;
      }

      button.hidden = false;
      button.disabled = false;

      button.setAttribute(
        'aria-pressed',
        matchingInput.checked ? 'true' : 'false'
      );

      availableButtons += 1;
    });

    /*
     * If Searchanise rebuilt the filters and some shortcuts
     * disappeared, rebuild the shortcut list from live values.
     */
    if (
      availableButtons < Math.min(6, getAvailableOptions(config).length)
    ) {
      renderButtons();
      return;
    }

    wrapper.hidden = availableButtons === 0;

    window.requestAnimationFrame(
      updateMobileScrollbar
    );
  };

  let syncScheduled = false;

  const scheduleSync = () => {
    if (syncScheduled) return;

    syncScheduled = true;

    window.requestAnimationFrame(() => {
      syncButtons();
      syncScheduled = false;
    });
  };

  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => {
      const target = mutation.target;

      if (
        target instanceof Node &&
        header.contains(target)
      ) {
        return false;
      }

      const element =
        target instanceof Element
          ? target
          : target?.parentElement;

      if (!element) return false;

      return Boolean(
        element.closest(
          '.snize-search-results, ' +
          '.snize-product-filters, ' +
          '.snize-product-filters-list, ' +
          '[id*="snize"]'
        )
      );
    });

    if (shouldSync) {
      scheduleSync();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'class',
      'checked',
      'aria-checked',
      'disabled'
    ]
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        '.snize-product-filters-checkbox'
      )
    ) {
      scheduleSync();
    }
  });

  /*
   * Searchanise may load after the section JavaScript,
   * so try immediately and then again shortly afterwards.
   */
  renderButtons();

  window.setTimeout(scheduleSync, 250);
  window.setTimeout(scheduleSync, 750);
  window.setTimeout(scheduleSync, 1500);
};

    headers.forEach(initialiseHeader);
  })();



  
(() => {
  const syncLoopiActiveFilters = () => {
    const containers = document.querySelectorAll(
      '#snize_results.snize-mobile-design.snize-new-version .snize-selected-filters-container'
    );

    containers.forEach((container) => {
      const activeFilters = Array.from(container.children).filter((child) => {
        return child.matches('span') && child.textContent.trim() !== '';
      });

      container.classList.toggle(
        'loopi-has-active-filters',
        activeFilters.length > 0
      );

      activeFilters.forEach((filter) => {
        let reset = filter.querySelector('i.snize-product-filters-reset');

        if (!reset) {
          reset = document.createElement('i');
          reset.className = 'snize-product-filters-reset';
          reset.setAttribute('aria-hidden', 'true');
          filter.appendChild(reset);
        }
      });
    });
  };

  syncLoopiActiveFilters();

  const observer = new MutationObserver(syncLoopiActiveFilters);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('click', () => {
    window.setTimeout(syncLoopiActiveFilters, 100);
    window.setTimeout(syncLoopiActiveFilters, 500);
  });
})();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
